"use client";

import { Placeholder } from "@lmn/design-system";
import React from "react";
import IconArrowRight from "@lmn/lastminute-react-icons/icons-converted/lastminute-icons-solid/IconArrowRight.js";
import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  max-width: 400px;
`;

export default function BreadcrumbsSkeleton() {
  return (
    <Container>
      <Placeholder variant="text" />
      <IconArrowRight />
      <Placeholder variant="text" />
    </Container>
  );
}
